import globals from "@/utils/globals";
import request from "@/utils/request";

export default (platform, segment) => request
  .get(globals.promotionsUrl, { params: {
    platform,
    segment,
    // Note: The `v` parameter is a cache buster mechanism to ensure every day gets a fresh cache entry to ensure
    // our sales campaigns switch properly on midnight UTC.
    v: `${new Date().getUTCDate()}-${new Date().getUTCMonth() + 1}-${new Date().getUTCFullYear()}`
  } })
  .then(data => {
    if (data) {
      return data;
    } else {
      throw new Error("No data found in /api/promotions response");
    }
  });
